


































































































































import { Component, Vue } from 'vue-property-decorator';
import { clientsModule, compilationsModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import { differenceInSeconds } from 'date-fns';
import ClientInfo from '@/components/ClientInfo.vue';

@Component({
  name: 'compilation-overview-page',
  components: {
    UserMenu,
    MainNavbar,
    ClientInfo,
  },
})
export default class compilationOverview extends Vue {
  currentDate = new Date();

  intervalId: undefined | number = undefined;

  mounted() {
    this.intervalId = setInterval(() => {
      this.currentDate = new Date();
    }, 60000);
  }

  beforeDestroy() {
    clearInterval(this.intervalId);
  }

  get client() {
    return clientsModule.model;
  }

  get compilation() {
    return compilationsModule.model;
  }

  // get status() {
  //   return this.compilation;
  // }

  get stylists() {
    return clientsModule.stylists;
  }

  get info() {
    if (this.compilation?.info) {
      try {
        return JSON.parse(this.compilation?.info as string);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
      }
    }
    return null;
  }

  get clientInfo() {
    return clientsModule.info;
  }

  get isStylist() {
    return !!this.stylists.find(stylist => stylist.id === this.client?.id);
  }

  get canComplete() {
    return this.compilation && (this.compilation.status === 'IN_PROGRESS'
      && (this.compilation.looks || []).length > 0
      && (this.compilation.things || []).length > 0
      && this.compilation.stylistComment);
  }

  get finished() {
    return this.compilation?.status === 'FINISHED';
  }

  setStatus(status: 'NEW' | 'IN_PROGRESS' | 'FINISHED') {
    if (this.compilation?.id != null) {
      compilationsModule.saveStatus({ compilationId: this.compilation?.id, status });
    }
  }

  setDeadline(deadlineMillis: number) {
    if (this.compilation?.id != null) {
      compilationsModule.saveDeadline({ compilationId: this.compilation?.id, deadlineMillis });
    }
  }

  setStylist(stylistId: number) {
    if (this.compilation?.id != null) {
      compilationsModule.assignStylist({ compilationId: this.compilation?.id, stylistId });
    }
  }

  getInfoFiledValue(id: number) {
    return this.info?.data.find((f: {id: number}) => f.id === id)?.value;
  }

  getServiceTitle() {
    const title = this.getInfoFiledValue(42);
    switch (title) {
      case 'Новый образ':
        return 'Образ из 5 вещей';
      case 'Новая капсула':
        return 'Капсула из 12 вещей';
      case 'Освежить гардероб':
        return 'Обновление гардероба';
      default:
        return title;
    }
  }

  takeOrders() {
    if (this.client?.id != null) {
      this.setStylist(this.client.id);
      this.setStatus('IN_PROGRESS');
    }
  }

  completeOrder() {
    this.$confirm('После отправки внести изменения будет невозможно', 'Отправить данный образ клиенту?', {
      confirmButtonText: 'Отправить',
      cancelButtonText: 'Отмена',
      type: 'warning',
    }).then(() => {
      if (this.canComplete) {
        this.setStatus('FINISHED');
      }
    });
  }

  get things() {
    return compilationsModule.things.filter(thing => !thing.clientItemId);
  }

  get looks() {
    return compilationsModule.looks;
  }

  get addedThings() {
    return this.things.filter(thing => thing.inWardrobe);
  }

  get dislikedThings() {
    return this.things.filter(thing => thing.dislike);
  }

  get addedLooks() {
    return this.looks.filter(() => false);
  }

  get dislikedLooks() {
    return this.things.filter(look => look.dislike);
  }

  // getClientInfoFiledValue(id: number) {
  //   return this.info?.data.find((f: {id: number}) => f.id === id).value;
  // }

  formatDuration(start: number | Date, finish: number | Date) {
    const diffTime = differenceInSeconds(finish, start);
    if (!diffTime) return '00:00'; // divide by 0 protection
    const minutes = Math.abs(Math.floor(diffTime / 60) % 60).toString();
    const hours = Math.abs(Math.floor(diffTime / 60 / 60)).toString();
    return `${diffTime < 0 ? '-' : ''}${hours.length < 2 ? 0 + hours : hours}ч ${minutes.length < 2 ? 0 + minutes : minutes}м`;
  }

  get stepFormLink() {
    return this.client ? `https://u014798.stepform.io/jpm9mP6?userId=${this.client.id}` : '';
  }

  copyLink() {
    if (this.client?.id != null) {
      navigator.clipboard.writeText(this.stepFormLink).then(() => {
        this.$notify({
          title: 'Ссылка на анкету скопирована',
          message: 'Вставьте в необходимом месте',
        });
      });
    }
  }
}
